<template>
  <v-card
    class="ma-0 py-2 px-4"
    style="background: #F5F5F5"
    outlined
    tile
  >
    <validation-observer ref="validator" v-slot="{ handleSubmit }">
      <h3 v-if="isCreate" class="form-title">
        Tạo SKU cho combo
      </h3>
      <h3 v-if="!isCreate" class="form-title">
        Sửa SKU cho combo
      </h3>
      <span class="close-btn cursor-pointer" @click="resetForm()">
        <v-icon color="#9e9e9e">
          mdi-close
        </v-icon>
      </span>
      <v-row>
        <v-col :cols="isShowFindSku ? 7 : 12">
          <v-row>
            <v-col cols="3" class="py-0 pt-2">
              <p class="text-bold mb-1">Mã SKU combo</p>
              <v-text-field
                class="text-field-custom"
                :clearable="true"
                placeholder="__"
                outlined
                dense
                readonly
                v-model="newSku.code"
              ></v-text-field>
            </v-col>
            <v-col cols="4" class="py-0 pt-2">
              <p class="text-bold mb-1">Tên SKU combo*</p>
              <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{ required: true}"
                  name="Tên SKU combo"
                >
                <v-text-field
                  class="text-field-custom"
                  :error-messages="errors"
                  :clearable="true"
                  placeholder="Nhập tên combo"
                  outlined
                  dense
                  maxLength="100"
                  v-model="newSku.name"
                ></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="5" class="py-0 pt-2">
              <p class="text-bold mb-1">Tên trên thẻ học*<i class="text-normal">(Tối đa 50 kí tự)</i></p>
              <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{ required: true}"
                  name="Tên trên thẻ học"
                >
                <v-text-field
                  class="text-field-custom"
                  :error-messages="errors"
                  :clearable="true"
                  placeholder="Tên trên thẻ học"
                  outlined
                  dense
                  maxLength="50"
                  v-model="newSku.cardDisplayName"
                ></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="1" class="py-0 pt-2"></v-col>
          </v-row>
          <v-row>
            <v-col cols="3" class="py-0 pt-4">
              <p class="text-bold mb-1">Mã SKU sản phẩm đơn lẻ*</p>
            </v-col>
            <v-col cols="4" class="py-0 pt-4">
              <p class="text-bold mb-1">Tên SKU*</p>
            </v-col>
            <v-col cols="4" class="py-0 pt-4">
              <v-row>
                <v-col cols="5" class="py-0">
                  <p class="text-bold mb-1">Số lượng*</p>
                </v-col>
                <v-col cols="7" class="py-0">
                  <p class="text-bold mb-1">Giá SKU*</p>
                </v-col>
              </v-row>
              
            </v-col>
          </v-row>

          <v-row v-for="(item, index) in comboItems" :key="index">
            <v-col cols="3" :key="'col-id' + keyRender" class="py-0">
              <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{ required: true}"
                  :name="'SKU_ID ' + (index + 1)"
                >
                <v-text-field
                  class="text-field-custom "
                  :error-messages="errors"
                  :clearable="true"
                  placeholder="Nhập SKU_ID"
                  outlined
                  dense
                  v-model="item.code"
                  @keyup="basicSearchForCombo(item, index, type = 'code')"
                ></v-text-field>
              </validation-provider>
              <p class="text-red mb-0" v-if="item.isError">Không tìm thấy SKU tương ứng</p>
            </v-col>
            <v-col cols="4" class="py-0" :key="'col' + keyRender">
              <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{ required: true}"
                  :name="'SKU sản phẩm ' + (index + 1)"
                >
                <v-autocomplete
                  class="text-field v-select-custom"
                  :error-messages="errors"
                  :clearable="true"
                  :items="item.skuSearchList"
                  item-value="code"
                  item-text="name"
                  :aLight="'right'"
                  placeholder="Chọn SKU sản phẩm"
                  attach
                  outlined
                  dense
                  @change="onSelectSku(item, index)"
                  :search-input.sync="item.textSearch"
                  v-model="item.codeSelect"
                  :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                ></v-autocomplete>
              </validation-provider>
            </v-col>
            <v-col cols="4" class="py-0">
              <v-row>
                <v-col cols="5" class="py-0">
                  <validation-provider
                    v-slot="{ errors }"
                    class="mb-2"
                    :rules="{ required: true, min_value: 1, alpha_num: true, max_value: 999 }"
                    :name="'Số lượng ' + (index + 1)"
                  >
                    <v-text-field
                      class="text-field-custom text-field-number"
                      :error-messages="errors"
                      :clearable="true"
                      placeholder="Số lượng"
                      outlined
                      dense
                      min="1"
                      type="number"
                      v-model="item.itemQuantity"
                      @change="onChangeQuantity(item);"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col cols="7" class="py-0">
                  <v-text-field
                    class="text-field-custom"
                    :clearable="true"
                    placeholder="Giá SKU"
                    outlined
                    dense
                    readonly
                    v-model="item.sumPrice"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="1" class="py-0 pt-3">
              <v-tooltip v-if="comboItems.length > 1" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="#585858" @click="deleteSku(index)" v-bind="attrs" v-on="on">
                    mdi-delete
                  </v-icon>
                </template>
                <span>Xóa</span>
              </v-tooltip>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12 py-0 pt-3">
              <div class="d-flex">
                <v-btn
                  class="btn-info cursor-pointer"
                  small
                  @click="addSku"
                >
                  + Thêm SKU
                </v-btn>

                <v-btn
                  class="btn-save mx-0 cursor-pointer"
                  small
                  @click="showFindSku"
                >
                  <v-icon color="#fff">
                    mdi-magnify
                  </v-icon>
                  Tìm kiếm nâng cao
                </v-btn>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" class="py-0 pt-2">
              <p class="text-bold mb-1">Giá Gốc</p>
              <v-text-field
                class="text-field-custom"
                :clearable="true"
                placeholder=""
                outlined
                dense
                readonly
                :value="orgAllPrice"
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="py-0 pt-2">
              <p class="text-bold mb-1">Giá Combo*</p>
              <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{ required: true, min_value: 0, alpha_num: true }"
                  name="Giá combo"
                >
                <v-text-field
                  class="text-field-custom text-field-number"
                  :error-messages="errors"
                  :clearable="true"
                  placeholder="Nhập giá"
                  outlined
                  dense
                  type="number"
                  min="0"
                  max="9999999999"
                  @change="isNeedUpdatePolicies = true"
                  v-model="newSku.comboPrice"
                ></v-text-field>
              </validation-provider>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" class="py-0">
              <p class="text-bold mb-1">Giao dịch*</p>
              <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{ required: true}"
                  name="Giao dịch"
                >
                <v-select
                  class="text-field"
                  :error-messages="errors"
                  :clearable="true"
                  :items="skuTransaction"
                  item-value="id"
                  item-text="name"
                  :aLight="'right'"
                  placeholder="Chọn"
                  attach
                  outlined
                  dense
                  v-model="newSku.transactionStatus"
                  :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                ></v-select>
              </validation-provider>
            </v-col>
            <v-col cols="6" class="py-0">
              <p class="text-bold mb-1">Trạng thái*</p>
              <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{ required: true}"
                  name="Trạng thái"
                >
                <v-select
                  class="text-field"
                  :error-messages="errors"
                  :clearable="true"
                  :items="skuStatus"
                  item-value="id"
                  item-text="name"
                  :aLight="'right'"
                  placeholder="Chọn"
                  attach
                  outlined
                  dense
                  v-model="newSku.status"
                  :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                ></v-select>
              </validation-provider>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="5" v-if="isShowFindSku" class="form-advance">
          <p class="text-bold mb-1">Tìm sản phẩm cho combo</p>
          <v-row>
            <v-col cols="6" class="py-0 pt-2">
              <v-select
                class="text-field-custom select-category"
                :clearable="true"
                :items="categories"
                item-value="id"
                item-text="name"
                :aLight="'right'"
                placeholder="Chọn danh mục"
                attach
                outlined
                dense
                multiple
                loader-height="1"
                v-model="filterSku.category_ids"
                :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
              ></v-select>
            </v-col>
            <v-col cols="6" class="py-0 pt-2">
              <v-select
                class="text-field-custom text-field-small"
                :clearable="true"
                :items="productTypes"
                item-value="id"
                item-text="name"
                :aLight="'right'"
                placeholder="Chọn Loại sản phẩm"
                attach
                outlined
                dense
                @change="onChangeSkuType"
                v-model="filterSku.product_type"
                :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="py-0 pt-2">
              <v-autocomplete
                class="text-field-custom text-field-small"
                :clearable="true"
                :items="productAttributes.subjects"
                item-value="id"
                item-text="name"
                :aLight="'right'"
                placeholder="Chọn Môn"
                attach
                outlined
                dense
                v-model="filterSku.subject_ids"
                :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6" class="py-0 pt-2">
              <v-autocomplete
                class="text-field-custom"
                :clearable="true"
                :items="productAttributes.grades"
                item-value="id"
                item-text="name"
                :aLight="'right'"
                placeholder="Chọn khối lớp"
                attach
                outlined
                dense
                multiple
                :disabled="isSearchTutorSku"
                v-model="filterSku.grade_ids"
                :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="py-0 pt-2">
              <v-autocomplete
                class="text-field-custom text-field-small"
                :clearable="true"
                :items="productAttributes.classTypes"
                item-value="id"
                item-text="name"
                :aLight="'right'"
                placeholder="Chọn Loại lớp"
                attach
                outlined
                dense
                v-model="filterSku.class_type_ids"
                :disabled="isSearchDuoSku"
                :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6" class="py-0 pt-2">
              <v-autocomplete
                class="text-field-custom text-field-small select-curriculum"
                :clearable="true"
                :items="curriculums"
                item-value="id"
                item-text="title"
                :aLight="'right'"
                placeholder="Chọn chương trình"
                attach
                outlined
                dense
                :disabled="isSearchDuoSku"
                v-model="filterSku.curriculum_id"
                :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="py-0 pt-2">
              <v-text-field
                class="text-field-custom text-field-small"
                :clearable="true"
                placeholder="Nhập mã sản phẩm"
                outlined
                dense
                v-model="filterSku.product_code"
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="py-0 pt-2">
              <v-autocomplete
                class="text-field-custom text-field-small"
                :clearable="true"
                :items="productAttributes.teacherTypes"
                item-value="id"
                item-text="name"
                :aLight="'right'"
                placeholder="Chọn loại giáo viên"
                attach
                outlined
                dense
                :disabled="isSearchDuoSku"
                v-model="filterSku.teacher_type_ids"
                :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="py-0 pt-2 text-center">
              <v-btn
                  class="btn-save mx-0 cursor-pointer"
                  small
                  @click="advanceSearchForCombo"
                >
                  Tìm kiếm
                </v-btn>
            </v-col>
          </v-row>

          <p class="text-bold mb-1">Chọn sản phẩm dưới đây</p>
          <div class="box-res-advance">
            <v-simple-table class="table-layout table-custom table-select-sku">
              <thead>
                <tr>
                  <th class="col-code text-left">Mã SKU</th>
                  <th class="col-name text-left">Tên SKU*</th>
                  <th class="col-price">Giá*</th>
                  <th class="col-action"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!listSkuSearch.length">
                  <td colspan="4">
                    <span v-if="isSearching">Đang tìm kiếm....</span>
                    <span v-if="!isSearching">Không có dữ liệu</span>
                  </td>
                </tr>
                <template v-if="listSkuSearch.length">
                  <tr v-for="(item, index) in listSkuSearch" :key="index">
                    <td class=" text-left">{{ item.code }}</td>
                    <td class=" text-left">{{ item.name }}</td>
                    <td>{{ formatCurrency(item.orgPrice) }}</td>
                    <td class="text-center">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon color="#4048FF" @click="addSkuFromAdvanceForm(item)" v-bind="attrs" v-on="on">
                            mdi-plus
                          </v-icon>
                        </template>
                        <span>Thêm vào combo</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </template>
              </tbody>
            </v-simple-table>
          </div>
          
        </v-col>
      </v-row>
      <v-row>
        <v-col :cols="isShowFindSku ? 7 : 12" class="text-center">
          <v-btn
            class="btn-success"
            small
            @click.prevent="handleSubmit(saveSkuCombo)"
          >
            <span v-if="isCreate">Tạo</span>
            <span v-if="!isCreate">Cập nhật</span>
          </v-btn>

          <v-btn
            class="btn-cancel"
            small
            @click="resetForm()"
          >
            Hủy
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-card>
</template>

<script>
import {
  productTypeDuo,
  productTypeTutor,
} from '../../../../helpers/constants';

import SkuCombo from '../../models/SkuCombo';

import RepositoryFactory from '@/repositories/RepositoryFactory';
const ProductRepository = RepositoryFactory.get('product');

export default {
  name: 'combo-form',
  components: {
  },
  props:{
    skuItems: {
      type: Array,
      default: () => [],
    },
    productAttributes: {
      type: Object,
      default: () => {},
    },
    categories: {
      type: Array,
      default: () => [],
    },
    sku: {
      type: Object,
      default: () => {},
    },
    isCreate: {
      type: Boolean,
      default: () => null,
    },
  },
  data() {
    return {
      comboItems: [
        // {
        //   code: null,
        //   itemType: null,
        //   itemId: null,
        //   name: null,
        //   isError: false,
        //   skuSearchList: [],
        //   orgPrice: 0,
        //   textSearch: null,
        // }
      ],
      isShowFindSku: false,
      isShowForm: false,
      tab: 0,
      isShowSku: false,
      listSkuSearch: [],
      filterSku: {
        category_ids: [],
        product_type: null,
        subject_ids: [],
        grade_ids: [],
        class_type_ids: [],
        teacher_type_ids: [],
        curriculum_id: null,
        product_code: null,
      },
      curriculums: [],
      newSku: new SkuCombo({}),
      keyRender: 0,
      skuTransaction: [],
      productTypes: [],
      isSearching: false,
      productTypeDuo,
      productTypeTutor,
      allSkus: [],
      isNeedUpdatePolicies: false,
    };
  },
  computed: {
    orgAllPrice() {
      return this.comboItems.reduce((accumulator, currentValue) => accumulator + currentValue.sumPrice, 0);
    },
    isSearchDuoSku() {
      return this.filterSku.product_type == this.productTypeDuo;
    },
    isSearchTutorSku() {
      return this.filterSku.product_type == this.productTypeTutor;
    },
  },
  async created() {
    this.getCurriculumAttributes();
    this.skuStatus = this.productAttributes.skuStatus;
    this.skuTransaction = this.productAttributes.skuTransaction;
    if (this.sku.name) {
      this.newSku = new SkuCombo(this.sku);
      this.comboItems = _.cloneDeep(this.sku.comboItems);
    }

    this.productTypes = this.productAttributes.productType.filter((item) => {
      if (item.id !== 'combo') {
        return item;
      }
    });
    await this.getAllSkus();

    if (this.isCreate) {
      this.addSku();
    }
  },
  beforeDestroy() {
  },
  methods: {
    onChangeSkuType() {
      this.filterSku.category_ids = [];
      this.filterSku.subject_ids = [];
      this.filterSku.grade_ids = [];
      this.filterSku.class_type_ids = [];
      this.filterSku.teacher_type_ids = [];
      this.filterSku.curriculum_id = null;
      this.filterSku.product_code = null; 
    },
    addSku() {
      this.comboItems.push({
        code: null,
        itemType: null,
        codeSelect: null,
        itemId: null,
        name: null,
        subjectId: null,
        isError: false,
        skuSearchList: this.allSkus,
        orgPrice: 0,
        sumPrice: 0,
        textSearch: null,
        itemQuantity: 1,
      });
      this.isNeedUpdatePolicies = true;
    },
    addSkuFromAdvanceForm(item) {
      const isExistSku = this.comboItems.find((itemC) => itemC.code === item.code);
      if (!isExistSku) {
        this.comboItems.push({
          code: item.code,
          codeSelect: item.code,
          itemType: this.filterSku.product_type,
          itemId: item.id,
          name: item.name,
          subjectId: item.subjectId,
          isError: false,
          skuSearchList: this.allSkus,
          orgPrice: item.orgPrice,
          sumPrice: item.orgPrice,
          textSearch: null,
          itemQuantity: 1,
        });
        this.isNeedUpdatePolicies = true;
      }
    },
    deleteSku(index) {
      if (this.comboItems.length === 1) {
        return;
      }
      this.comboItems.splice(index, 1);
      this.isNeedUpdatePolicies = true;
    },
    basicSearchForCombo: _.debounce(async function(item, index, type = null) {
      item.itemId = null;
      item.codeSelect = null;
      item.orgPrice = null;
      item.sumPrice = null;
      item.itemQuantity = 1;
      const params = {
        sku_code: item.code,
        sku_name: null,
      }
      if (!item.code) {
        delete params.sku_code;
      }

      const res = this.allSkus.find((itemSearch) => item.code === itemSearch.code);

      if (!res) {
        if (item.code) {
          item.isError = true;
        }
        if (!item.code) {
          item.isError = false;
        }
      }
      if (res) {
        const isExistItem = this.comboItems.find((itemSearch, indexSearch) => {
          if (item.code === itemSearch.code && index != indexSearch ) {
            return itemSearch;
          }
        });
        if (isExistItem) {
          this.$swal({
            type: 'error',
            title: 'Lỗi!',
            text: 'SKU đã bị trùng',
          });
          return;
        }

        item.itemType = res.itemType;
        item.name = res.name;
        item.orgPrice = res.orgPrice;
        item.sumPrice = res.orgPrice;
        item.subjectId = res.subjectId;
        item.itemId = res.id;
        item.itemQuantity = 1;
        item.codeSelect = res.code;
        item.isError = false;
        this.isNeedUpdatePolicies = true;
        return;
      }
    }, 500),

    async getAllSkus() {
      const params = {
        sku_name: '',
      }
      const res = await ProductRepository.basicSearchForCombo(params);
      this.allSkus = res.data;
    },

    onSelectSku(item, index) {
      const isExistItem = this.comboItems.find((itemSearch, indexSearch) => {
        if (item.codeSelect === itemSearch.code && index != indexSearch ) {
          return itemSearch;
        }
      });
      if (isExistItem) {
        this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: 'SKU đã bị trùng',
        });
        item.code = null;
        item.itemId = null;
        item.itemType = null;
        item.itemQuantity = 1;
        item.name = null;
        item.orgPrice = null;
        item.sumPrice = null;
        item.isError = false;
        return;
      }

      if (!item.codeSelect) {
        item.code = null;
        item.itemId = null;
        item.itemType = null;
        item.itemQuantity = 1;
        item.name = null;
        item.orgPrice = null;
        item.sumPrice = null;
        item.isError = false;
      }
      if (item.codeSelect) {
        const skuSelected = item.skuSearchList.find((itemS) => itemS.code === item.codeSelect);
        this.keyRender++;
        item.code = skuSelected.code;
        item.itemType = skuSelected.itemType;
        item.itemId = skuSelected.id;
        item.itemQuantity = 1;
        item.name = skuSelected.name;
        item.orgPrice = skuSelected.orgPrice;
        item.sumPrice = skuSelected.orgPrice;
        item.subjectId = skuSelected.subjectId;
        this.isNeedUpdatePolicies = true;
        item.isError = false;
      }
    },

    advanceSearchForCombo: _.debounce(async function() {
      this.listSkuSearch = [];
      if (!this.filterSku.product_type) {
        this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: 'Chưa chọn loại sản phẩm',
        });
        return;
      }
      this.isSearching = true;
      const params = {
        product_type: this.filterSku.product_type,
        product_code: this.filterSku.product_code,
        category_ids: this.filterSku.category_ids,
        subject_ids: this.filterSku.subject_ids,
        grade_ids: this.filterSku.grade_ids,
        class_type_ids: this.filterSku.class_type_ids,
        teacher_type_ids: this.filterSku.teacher_type_ids,
        curriculum_id: this.filterSku.curriculum_id,
      };

      if (!this.filterSku.product_code) {
        delete params.product_code
      }
      const res = await ProductRepository.advanceSearchForCombo(params);
      this.isSearching = false;
      this.listSkuSearch = res.data;
    }, 500),

    async getCurriculumAttributes() {
      const res = await ProductRepository.getCurriculumAttributes();
      this.curriculums = res.data;
    },
    resetForm() {
      this.$swal
        .fire({
          title: "Bạn muốn đóng form? Tất cả thông tin sẽ bị mất!",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Hủy",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Đồng ý",
        })
        .then( async (result) => {
          if (result?.value) {
            this.$emit('close');
          }
        });
    },
    showFindSku() {
      this.isShowFindSku = true;
      this.$emit('showFindSku');
    },
    saveSkuCombo() {
      if (this.isNeedUpdatePolicies && this.newSku.id) {
        this.$swal.fire({
          title: "Khi cập nhật lại combo cần thực hiện cài đặt lại chính sách giá.",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Hủy",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Đồng ý",
        })
        .then( async (result) => {
          if (result?.value) {
            this.newSku.comboItems = this.comboItems;
            this.newSku.orgPrice = this.orgAllPrice;
            this.$emit('saveSku', this.newSku);
            this.$emit('close');
          }
        });
      }
      if (!this.isNeedUpdatePolicies || !this.newSku.id) {
        this.newSku.comboItems = this.comboItems;
        this.newSku.orgPrice = this.orgAllPrice;
        this.$emit('saveSku', this.newSku);
        this.$emit('close');
      }
    },
    onChangeQuantity(item) {
      item.sumPrice = item.itemQuantity * item.orgPrice;
      this.isNeedUpdatePolicies = true;
    },
  },
  watch: {
  }
};
</script>
<style scoped lang="scss">
  .box-res-advance {
    max-height: 350px;
    overflow-y: auto;
  }
  .btn-save {
    background: #8465FF !important;
    color: #fff;
  }
  .btn-cancel  {
    background: #787878 !important;
    color: #fff;
    min-width: 80px !important;
  }

  .btn-info {
    background: #6587FF !important;
    color: #fff;
  }

  .icon-search {
    left: 40px;
    position: relative;
  }
  .table-custom {
    th {
      background: #E7E8FF;
      border-left: 1px solid #fff;
    }
  }
  .form-advance {
    border-left: 1px solid #ccc;
  }
  .table-select-sku th {
    min-width: 40px;
  }
  .btn-success {
    background: #048F0A !important;
    color: #fff;
    min-width: 80px !important;
  }
  .col-code {
    width: 20%;
  }
  .col-name{
    width: 40%;
  }
  .col-price{
    width: 30%;
  }
  .col-action{
    width: 10%;
  }
  .form-title {
    position: absolute;
  }
  .close-btn {
    position: relative;
    left: 98%;
  }
</style>

<style lang="scss">
  .text-normal {
    font-weight: normal;
  }
  .text-field-small {
    .v-input__slot {
      height: 35px;
      min-height: 20px !important;
    }
  }
  .text-field fieldset {
    background: #fff !important;
  }
  .text-search {
    .v-input__slot {
      min-height: 20px !important;
      padding-left: 35px !important;
    }
  }
 
  .text-field-custom {
    fieldset {
      background: #fff !important;
    }
  }
  .text-bold {
    font-weight: bold;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .text-red {
    color: red;
    font-size: 12px;
    margin-top: -20px;
  }

  .form-advance {
    .v-list-item__action {
      margin-right: 0 !important;
    }

    .select-curriculum {
      .v-menu__content {
        left: -85px !important;
        min-width: 290px !important;
      }
    }

    .select-category {
      .v-menu__content {
        min-width: 350px !important;
      }
    }
  }
</style>
